import { FC, ReactElement, memo, useCallback, useMemo } from 'react';
import { mealChoiceEditModalStore } from '../../store/mealChoiceEditModalStore';
import integrationsStore from '~/mobx/integrationStore';
import { IMealItem } from '~/types/combo';
import { isDisabledByPos } from '~/utils/helpers';
import { TOOLTIP_DURATION, TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import Input from '~/view/components/Controls/InputComponent/Input';
import IntegrationManager from '~/view/components/IntegrationManager/IntegrationManager';
import Text from '~/view/components/Text/Text';

interface IProps {
  item?: IMealItem;
  sizeId: number;
}

export const MealChoiceEditModalItemPrice: FC<IProps> = memo((props: IProps): ReactElement => {
  const { comboMealChangeDiscountPrice } = integrationsStore.posRestrictions || {};
  const _isDisabledByPos = useMemo((): boolean => isDisabledByPos(comboMealChangeDiscountPrice), [comboMealChangeDiscountPrice]);

  const priceDisabled = useMemo((): boolean => !props.item && !_isDisabledByPos, [props.item, _isDisabledByPos]);
  const titleDisabled = useMemo((): boolean => _isDisabledByPos || priceDisabled, [priceDisabled, _isDisabledByPos]);

  const onChangePrice = useCallback(
    (value: string | undefined) => {
      mealChoiceEditModalStore.onChangeItemPrice(props.sizeId, value);
    },
    [props.sizeId]
  );

  return (
    <div className="d-flex flex-column mt-4">
      <Text
        type="block-header"
        text="discounted_price"
        disabled={titleDisabled}
        tooltip={{
          message: 'hint_cmgci_discounted_price',
          duration: TOOLTIP_DURATION.EXTRA_LARGE,
          position: TOOLTIP_POSITION.PORTAL,
          iconSize: 16,
        }}
      />

      <IntegrationManager
        setting={comboMealChangeDiscountPrice}
        wrapperClassName="mt-2"
        tooltipOptions={{ position: TOOLTIP_POSITION.PORTAL }}
        withTooltip
      >
        <Input type="floatNumber" value={props.item?.price} onChangeValue={onChangePrice} disabled={priceDisabled} contentClassName="full-width" />
      </IntegrationManager>
    </div>
  );
});
